import React from "react"
import Loader from "components/loader"
import Flex from "./shared/flex"

const FullPageProgress = () => (
  <Flex justify="center" align="center" css={{ width: "100%", height: "100vh" }}>
    <Loader width="50" height="50" />
  </Flex>
)

export default FullPageProgress
